import { render, staticRenderFns } from "./FooterEmailCollection.vue?vue&type=template&id=059d47b4&lang=pug&"
import script from "./FooterEmailCollection.vue?vue&type=script&lang=js&"
export * from "./FooterEmailCollection.vue?vue&type=script&lang=js&"
import style0 from "./FooterEmailCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059d47b4')) {
      api.createRecord('059d47b4', component.options)
    } else {
      api.reload('059d47b4', component.options)
    }
    module.hot.accept("./FooterEmailCollection.vue?vue&type=template&id=059d47b4&lang=pug&", function () {
      api.rerender('059d47b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/footer/FooterEmailCollection.vue"
export default component.exports